module.exports = __webpack_public_path__ + "imgs/src/assets/imgs/icon//icon-coin_88x100.png?v=3a484a2d";